export const ikaMapDataLoading = (state:any) => state.ikaMap.loading;
export const ikaMapData = (state:any) => state.ikaMap.IKAMaps;

export const ikaMapCountries = (state:any) => state.ikaMap.countries;
export const ikaMapCountriesLoading = (state:any) => state.ikaMap.countriesLoading;

export const inputSuggestions = (state:any) => state.ikaMap.inputSuggestions;
export const error = (state:any) => state.ikaMap.error;

export const costCategoryData = (state:any) => state.costCategory.CostCategoriesMapping;
export const costCategoryDataLoading = (state:any) => state.costCategory.loading;